const comments = [
  {
    name: '吃瓜小能手',
    avatar: 'G',
    time: '2 小时前',
    content: '这个站更新真快啊，每天打开都能看到新瓜，已经成了我的每日必刷！吃瓜合集整理得特别清晰，找旧瓜也很方便。',
    likes: 128,
  },
  {
    name: '娱乐观察员',
    avatar: 'Y',
    time: '5 小时前',
    content: '终于有个靠谱的吃瓜地方了！之前各种群消息真假难辨，这里每条都有来源标注，能放心吃了。热度榜功能也很实用。',
    likes: 96,
  },
  {
    name: '瓜田里的猹',
    avatar: 'C',
    time: '8 小时前',
    content: '吃瓜合集真的太赞了，按专题分类一目了然。最近追的几个瓜都在这里找到完整的时间线，强烈推荐给所有吃瓜爱好者！',
    likes: 203,
  },
  {
    name: '深夜吃瓜人',
    avatar: 'S',
    time: '1 天前',
    content: '娱乐吃瓜就认准今日大瓜了！更新速度快、内容靠谱、分类清晰，深夜睡不着就刷一刷，总能发现新鲜好瓜。',
    likes: 77,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">听听吃瓜群众怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {comments.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-bold text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.content}</p>
              <div className="flex items-center gap-1 mt-3 pt-3 border-t border-background-200">
                <i className="ri-heart-line text-primary-400 text-sm"></i>
                <span className="text-xs text-foreground-400">{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}